module.exports = __webpack_public_path__ + "img/menu3.15eec555.svg";